import { render, staticRenderFns } from "./CustomersList.vue?vue&type=template&id=a742c308&scoped=true&"
import script from "./CustomersList.vue?vue&type=script&lang=js&"
export * from "./CustomersList.vue?vue&type=script&lang=js&"
import style0 from "./CustomersList.vue?vue&type=style&index=0&id=a742c308&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a742c308",
  null
  
)

export default component.exports